module.exports = __webpack_public_path__ + "static/img/5.a3d692b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/newbieGuide/img/5.png
// module id = 9IZD
// module chunks = 115